import React from 'react';
import LoaderImg from '../../../assets/images/loader1.gif';

export default function Loader() {
  return (
    <React.Fragment>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          zIndex: 9999,
        }}
      >
        <img src={LoaderImg} width={90} alt="...Loading" />
      </div>
    </React.Fragment>
  );
}
